import Api from 'src/api/Base'

class GetSpaceById extends Api {
  requestUrl = `/api/space/${this.getParams().id}`
}

export default GetSpaceById
